import React from 'react'
import Header from './components/Header';
import Footer from './components/Footer';
import { useState,useEffect } from 'react';
import './styles/motoStyles.css';
import lotus from '../src/images/lotus.png';

const Intellectual = () => {
  const [fadeOut, setFadeOut] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setFadeOut(true);
    }, 500);

    return () => clearTimeout(timer);
  }, []);

    
    useEffect(() => {
      const handleScroll = () => {
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        
        if (scrollTop > 50) {
          setScrolled(true);
        } else {
          setScrolled(false);
        }
      };
    
      window.addEventListener("scroll", handleScroll);
      handleScroll();
    
      return () => {
        window.removeEventListener("scroll", handleScroll);
      };
    }, []);
  return (
    <div>
      <div className={`moto ${fadeOut ? 'fade-out' : ''}`}>
        <h1>Intellectual Property Rights Law here at KWA</h1>
      </div>
      <Header scrolled={scrolled}/>
      <div className='justify-content-center d-flex align-items-center w-100 fs-4' style={{minHeight:'100vh',padding:'10%',paddingTop: '5%',paddingBottom: '5%'}}>
        <img src={lotus} alt='' className='lotus'></img>
        <div className=''><p>Welcome to <span className="kwa">KWA</span>, where innovation converges with protection within the dynamic realm of <span className="highlight">intellectual property law</span>. We are delighted to introduce our distinguished  Intellectual Property Rights Division which provides a comprehensive array of legal services meticulously tailored to meet the diverse requirements of our esteemed clientele. With an unwavering dedication to excellence and strict adherence to statutory obligations, our adept team adeptly navigates the intricacies of intellectual property law with precision and effectiveness.</p>
        <br />
        <p>At <span className="kwa">KWA</span>, we recognize the paramount importance of preserving intellectual property rights amidst India's rapidly evolving commercial landscape. Our practice is underpinned by a steadfast commitment to upholding the highest standards of legal integrity, ensuring that our clients' intellectual assets remain shielded in accordance with pertinent legislation, including but not limited to:</p>
            <p>The Indian Copyright Act, 1957: Regulating copyright protection for literary, artistic, and musical works, affording creators exclusive rights to reproduce, distribute, and publicly perform their works.
        <br />
        <br />
        The Trade Marks Act, 1999: Governing the registration and safeguarding of trademarks, enabling businesses to differentiate their goods and services from competitors and deter unauthorized usage.
        <br />
        <br />
        The Patents Act, 1970: Facilitating the grant of patents for inventions, endowing inventors with exclusive rights to exploit their innovations for a limited duration, thereby fostering innovation and technological progress.
        <br />
        <br />
        The Designs Act, 2000: Safeguarding the aesthetic aspects of industrial designs, granting designers exclusive rights to utilize their designs for commercial purposes and prevent unauthorized replication.</p>
        <br />
        <p>With a nuanced comprehension of these statutes and their ramifications, our team offers strategic counsel and representation to clients spanning a broad spectrum of intellectual property affairs. From <span className="highlight">trademark registration</span> and <span className="highlight">patent prosecution</span> to <span className="highlight">copyright enforcement</span> and <span className="highlight">IP litigation</span>, we furnish bespoke solutions crafted to safeguard our clients' intellectual assets and optimize their commercial viability.</p>
        <br />
        <p>Contact us today to discover how <span className="kwa">KWA’s</span> Intellectual Property Rights Division can assist you in safeguarding and maximizing the value of your intellectual assets in India with confidence and efficacy.</p></div>
      </div>
      <Footer />
    </div>
  )
}

export default Intellectual
